import {
  UnionCircle,
  VectorIcon,
  VectorSuccessIcon,
} from '@dynamika-shared/ui/icons';

import { DotsLoadingSpinner } from '@dynamika-shared/ui/LoadingSpinner/DotsLoadingSpiner';
import { FC } from 'react';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { twJoin } from '@utils/twMerge';

type LoadingFileProps = {
  text: string | undefined;
  currentSubStep?: number | null;
  subTitle: string;
  warningCount?: number;
  nextButtonEnabled?: boolean;
  setCurrentStep?: (val: number) => void;
  spinnerType?: 'Circle' | 'Semicircle';
  currentStep?: number;
  tryAgainButton?: boolean;
  tryAgainFunc?: () => void;
  semicircleColor?: string;
  tryAgainText?: string;
  spinnerFill?: string;
};

const TOTAL_STEPS = 2;

export const LoadingFile: FC<LoadingFileProps> = ({
  text,
  currentSubStep,
  subTitle,
  nextButtonEnabled,
  setCurrentStep,
  spinnerType = 'Circle',
  warningCount,
  currentStep,
  tryAgainButton,
  tryAgainFunc,
  semicircleColor = 'text-vividTangelo',
  tryAgainText = 'Try Again',
  spinnerFill = 'bg-vermilion',
}) => {
  const handleButtonClick = () => {
    if (setCurrentStep && currentStep) {
      setCurrentStep(currentStep + 1);
    }
  };

  return (
    <div className='flex h-full w-full flex-col items-center justify-between text-center'>
      <div></div>
      <div className='flex w-full flex-col items-center justify-center'>
        <div>
          {spinnerType === 'Circle' && <DotsLoadingSpinner />}

          {spinnerType === 'Semicircle' && (
            <div className='relative flex items-center justify-center'>
              <UnionCircle
                className={twJoin(semicircleColor, 'h-10 w-10 animate-spin')}
              />
              <p className='absolute text-[36px] font-semibold text-vividTangelo'>
                {warningCount}
              </p>
              {tryAgainButton && !warningCount && (
                <div
                  className={twJoin(
                    spinnerFill,
                    'absolute flex h-[37px] w-[37px] items-center justify-center rounded-full '
                  )}
                >
                  {spinnerFill === 'bg-yellowGreen' ? (
                    <VectorSuccessIcon />
                  ) : (
                    <VectorIcon className='w-[7.5px ] h-[7.5px]' />
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <h3 className='w-full break-words pb-1 pt-2 text-1624 font-semibold text-chineseBlack'>
          {text}
        </h3>
        <p className='whitespace-pre text-center text-1216 text-spanishGray'>
          {subTitle}
        </p>

        {tryAgainButton && (
          <Button
            className='mt-5 flex h-5 w-[116px] items-center rounded-3xl !border-chineseBlack !bg-blackOlive px-3 py-1 text-1424 font-semibold !text-white transition ease-in hover:!bg-blue-500'
            onClick={tryAgainFunc}
          >
            {tryAgainText}
          </Button>
        )}

        {nextButtonEnabled && (
          <Button
            className='mt-5 w-[13rem] rounded-3xl !border-chineseBlack !bg-blackOlive px-3 py-1 text-1424 font-semibold !text-white transition ease-in hover:!bg-blue-500'
            onClick={handleButtonClick}
          >
            Resolve
          </Button>
        )}
      </div>

      {currentSubStep ? (
        <div>
          <p className='flex items-end align-bottom text-1424 font-semibold text-spanishGray'>
            <span className='pr-0.5 text-1624 text-vividTangelo leading-[24px]'>
              {currentSubStep}
            </span>
            <span>/</span>
            <span className='leading-[23px]'>{TOTAL_STEPS}</span>
          </p>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};
